"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowOfSeats = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const config_1 = require("../config");
const Seat_1 = require("../Seat");
const className = 'seat-selection-aircraft';
class RowOfSeats extends react_1.default.PureComponent {
    render() {
        const { columnLabels, isAllowedToEditLabels, isBlue, isExitDoorExists, onSeatClick, onSeatDoubleClick, rowLabel, rowPrices, rowSeats, selectedSeats, activeSeats, mode, disabled: disabledRow, } = this.props;
        const rowLabelClassNames = (0, classFunctions_1.getClassNames)(`${className}__column`, [
            isExitDoorExists ? 'exit' : undefined,
        ]);
        const rowLabelInputClass = [
            rowLabel ? `${className}__row-number` : '',
            isExitDoorExists ? `${className}__exit` : '',
        ];
        const showLabel = rowLabel || isExitDoorExists;
        return (react_1.default.createElement("div", { className: `${className}__row` },
            showLabel && (react_1.default.createElement("div", { className: rowLabelClassNames },
                react_1.default.createElement("input", { type: 'text', className: rowLabelInputClass.join(' '), defaultValue: rowLabel, readOnly: !isAllowedToEditLabels }))),
            rowSeats.map((seat, idx) => {
                const seatLabel = ((rowLabel && columnLabels[idx])
                    ? `${rowLabel}${columnLabels[idx]}`
                    : 'undefined');
                const isPassage = !/\d+/.test(rowLabel) || columnLabels[idx].trim() === '';
                const isClickable = mode === 'select' ? (0, config_1.checkSeatClickableForSelect)(seat) : !isPassage && (0, config_1.checkSeatClickableForEdit)(seat);
                const active = activeSeats.some(activeSeatLabel => (activeSeatLabel === seatLabel));
                const disabled = disabledRow || (0, config_1.checkSeatDisabled)(seat);
                const selected = selectedSeats.some(selectedSeatLabel => (selectedSeatLabel === seatLabel));
                const hidden = (0, config_1.checkSeatAbsent)(seat);
                const reserved = (0, config_1.checkSeatReserved)(seat);
                const booked = (0, config_1.checkSeatBooked)(seat);
                const bordered = mode === 'edit' && (0, config_1.checkSeatAbsent)(seat);
                const showPrice = !disabled && !hidden;
                const seatData = {
                    isClickable,
                    active,
                    disabled,
                    selected,
                    hidden,
                    reserved,
                    booked,
                    bordered,
                    row: rowLabel,
                    column: columnLabels[idx],
                    price: showPrice ? `${rowPrices[idx]} CHF` : undefined,
                    modificators: isBlue ? 'blue' : undefined,
                };
                const showSeat = !(0, config_1.checkSeatAbsent)(seat) || mode === 'edit';
                return (react_1.default.createElement("div", { key: `rassaspros::${idx}::rowLabel:${rowLabel}`, className: `${className}__column` }, showSeat && (react_1.default.createElement(Seat_1.AircraftSeat, { ...seatData, onSeatClick: onSeatClick, onSeatDoubleClick: onSeatDoubleClick }))));
            }),
            showLabel && (react_1.default.createElement("div", { className: rowLabelClassNames },
                react_1.default.createElement("input", { className: rowLabelInputClass.join(' '), defaultValue: rowLabel, readOnly: true, type: 'text' })))));
    }
}
exports.RowOfSeats = RowOfSeats;
RowOfSeats.defaultProps = {
    columnLabels: [],
    isAllowedToEditLabels: false,
    isBlue: false,
    isExitDoorExists: false,
    onSeatClick: () => {
    },
    onSeatDoubleClick: () => {
    },
    mode: 'select',
    rowLabel: '',
    rowPrices: [],
    rowSeats: [],
};
//# sourceMappingURL=index.js.map